<!--
 * @Description: 发起提现
 * @Date: 2019-10-29 10:21:46
 * @LastEditors: Ji Yinghao
 * @LastEditTime: 2019-10-29 18:34:01
 -->

<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <span>发起提现</span>
          <v-spacer></v-spacer>
          <v-menu bottom left>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" @click="()=>{dialog = false}">
                <v-icon>close</v-icon>
              </v-btn>
            </template>
          </v-menu>
        </v-card-title>
        <v-card-text class="black--text">
          <v-card-text>
            <div>可提现金额</div>
            <p class="display-1 text--primary">{{ (data.withdrawal/100).toFixed(2) }} <span style="font-size: 14px;" >元</span> </p>
            <p> <img src="../../assets/wei.svg" alt=""><span class="wei_" >微信提现</span> </p>
            <div class="text--primary">
              1. 需要您已注册微信并绑定手机号。
              <br />2. 打开微信，点击：我->支付->收付款->二维码收款->保存收款码。
            </div>
          </v-card-text>
              <v-col cols="12" sm="12" md="12" class="mx-auto">
                <v-text-field label="输入提现金额（元）" outlined color="black" v-model="value"></v-text-field>
                <v-file-input
                  v-model="files"
                  color="deep-purple accent-4"
                  label="上传微信收款二维码"
                  placeholder
                  prepend-icon=""
                  outlined
                  :show-size="1000"
                  @change="()=>{}"
                >
                  <template v-slot:selection="{ index, text }">
                    <v-chip
                      v-if="index < 2"
                      color="deep-purple accent-4"
                      dark
                      label
                      small
                    >{{ text }}</v-chip>
                    <span
                      v-else-if="index === 2"
                      class="overline grey--text text--darken-3 mx-2"
                    >+{{ files.length - 2 }} File(s)</span>
                  </template>
                </v-file-input>
              </v-col>
              <div class="my-2" style="text-align: right;margin-right: 15px;">
                <v-btn color="primary" @click="sub"> 确认提现 </v-btn>
              </div>
            <v-list-item-content></v-list-item-content>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" text @click="withdrawList_">提现记录</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 提现记录 -->
    <WithdrawList ref="WithdrawList"></WithdrawList>
  </v-row>
</template>

<script>
import WithdrawList from '../../components/home/withdrawList.vue'
export default {
  components:{
    WithdrawList
  },
  data() {
    return {
      dialog: false,
      value: "",
      files: null,
      data: {}
    };
  },
  methods: {
    info(state, data) {
      this.dialog = state;
      this.data = data;
    },
    back(){
      this.dialog = true;
    },
    /* 提现列表 */ 
    withdrawList_(){
      this.dialog = false;
      this.$refs.WithdrawList.info( true );
    },
    /* 提现提交 */ 
    sub(){
      window.console.log( this.value-0 )
      if( !this.isNumber( this.value ) ){
         return this.$Dialog.getProductCheckResult_({text: `提现金额，请输入大于1并小于${ (this.data.withdrawal/100).toFixed(2) }的数字！`,timeout: 3000, snackbar: true }); 
         }
      if( this.value-0 <= 0 || this.value-0 >= this.data.withdrawal/100 ){
         return this.$Dialog.getProductCheckResult_({text: `提现金额，请输入大于1并小于${ (this.data.withdrawal/100).toFixed(2) }`,timeout: 3000, snackbar: true }); 
         }
      if( this.files == null ){
         return this.$Dialog.getProductCheckResult_({text: `收款码，请选择您的微信收款码！`,timeout: 3000, snackbar: true }); 
         }
      // order_transfer
      let formData = new FormData();
          formData.append("file", this.files);
          formData.append("fee", (this.value-0)*100);
      this.$axios({
        method: "post",
        url: this.$apis.URL.order_transfer,
        data: formData
      })
        .then((req) => {
          if(req.data.result == 0){
            this.$Dialog.getProductCheckResult_({text: `您的提现提交成功！请等待审核...`,timeout: 30000, snackbar: true });
            this.dialog = false;
            this.$parent.$parent.doctorInfo();
          }else{
            this.$Dialog.getProductCheckResult_({text: req.data.message,timeout: 3000, snackbar: true });
          }
        })
        .catch(error => {
          this.$Dialog.getProductCheckResult_({text: error,timeout: 3000, snackbar: true });
        });
    },
    /* 验证金额 */ 
    isNumber(val) {
    var regPos = /^\d+(\.\d+)?$/; //非负浮点数
    var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
    if(regPos.test(val) || regNeg.test(val)) {
        return true;
        } else {
        return false;
        }
    }
  }
};
</script>

<style lang="scss" scoped>
.wei_{
  position: relative;
  top: -10px;
  left: 10px;
}
</style>